module.exports = __webpack_public_path__ + "static/media/synth_14.b59b3859.mp3";